import { Clock, PlayCircle, ShieldCheck, CheckCircle2, XCircle, AlertTriangle } from "lucide-react";

export const NCR_STATUSES = [
  { key: 'pending_ph_approval', label: 'Pending PH Approval', color: 'orange', icon: Clock },
  { key: 'in_progress', label: 'In Progress', color: 'purple', icon: PlayCircle },
  { key: 'pending_verification', label: 'Pending Verification', color: 'teal', icon: ShieldCheck },
  { key: 'closed', label: 'Closed', color: 'green', icon: CheckCircle2 },
  { key: 'rejected', label: 'Rejected', color: 'red', icon: XCircle },
  { key: 'overdue', label: 'Overdue', color: 'red', icon: AlertTriangle },
];

export const NCR_STATUS_MAP = {
  closed: { label: "Closed", color: "green" },
  assigned_to_maker: { label: "Assigned to Maker", color: "blue" },
  resubmission_required: { label: "Resubmission Required", color: "orange" },
  maker_submitted: { label: "Pending Verification", color: "teal" },
  pending_verification: { label: "Pending Verification", color: "teal" },
  in_progress: { label: "In Progress", color: "purple" },
  draft: { label: "Draft", color: "amber" },
  rejected: { label: "Rejected", color: "red" },
  overdue: { label: "Overdue", color: "red" },
  pending_ph_approval: { label: "Pending PH Approval", color: "orange" },
  project_head_pending: { label: "Project Head Pending", color: "orange" },
  project_head_rejected: { label: "Project Head Rejected", color: "red" },
};

export const formatNCRStatus = (status) => {
  if (!status) return "";
  const s = String(status).trim();
  const lower = s.toLowerCase();

  if (NCR_STATUS_MAP[lower]) {
    return NCR_STATUS_MAP[lower].label;
  }

  // Remove underscores and format in Title Case
  return s
    .replace(/_/g, " ")
    .split(/\s+/)
    .map((word, idx) => {
      const wLower = word.toLowerCase();
      if (wLower === "ph" || wLower === "qc" || wLower === "ncr") {
        return wLower.toUpperCase();
      }
      if (idx > 0 && ["to", "of", "in", "for", "and", "the", "by", "on", "at"].includes(wLower)) {
        return wLower;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};
